import {
  Device,
  MonitoringLevel,
  hasEndpointStatistics,
  hasGenericStatistics,
  hasMcuStatistics,
} from "@services/devices/types";

export const canShowGraph = (device?: Device) =>
  Boolean(
    device?.monitoringLevel != MonitoringLevel.None &&
      device?.room &&
      device?.room.managed
  );

export const monitoringSource = (device?: Device) =>
  device?.monitoringSources ? device?.monitoringSources.join("|") : "";

const isDMCA = (device?: Device) =>
  monitoringSource(device).indexOf("AVI-SPL Monitoring Agent") != -1;

export const canBePinged = (device?: Device) =>
  Boolean(
    canShowGraph(device) &&
      (isDMCA(device) ||
        (device?.ipAddress &&
          device?.ipAddress != "" &&
          device?.ipAddress != "0.0.0.0" &&
          device?.model != "Symphony CommProxy" &&
          monitoringSource(device).indexOf("CommProxy") != -1))
  );

export const canShowRealtimeData = (device?: Device) =>
  Boolean(
    canBePinged(device) ||
      hasEndpointStatistics(device) ||
      hasGenericStatistics(device) ||
      hasMcuStatistics(device)
  );
